module.exports = __webpack_public_path__ + "img/confetti_4b.b95cbb5b.svg";